/* eslint no-param-reassign: ["error", { "props": false }] */
import difference from 'lodash/difference';

import { editUnitList } from 'Root/http';
import { unflattenEntities } from 'shared/components/Tree/treeUtils';


export function getDifference(originalSelected = [], selected) {
  return {
    added: difference(selected, originalSelected),
    deleted: difference(originalSelected, selected),
  };
}

function chunkArray(array, chunkSize = 100) {
  return array.reduce((all, one, i) => {
    const ch = Math.floor(i / chunkSize);
    all[ch] = [].concat((all[ch] || []), one);
    return all;
  }, []);
}

export function savePack({ id, key, pack }) {
  const packStr = pack.join(', ');
  const body = { id, [key]: packStr };
  return editUnitList(body);
}

export function saveGroupUnits(id, original, selected) {
  const diff = getDifference(original, selected);
  // added deleted
  const addedPacks = chunkArray(diff.added, 100)
    .map(pack => ({ id, key: 'addUnitArray', pack }));
  const deletedPacks = chunkArray(diff.deleted, 100)
    .map(pack => ({ id, key: 'deleteUnitArray', pack }));
  const packs = addedPacks.concat(deletedPacks);
  let lastPromise = Promise.resolve();
  for (let i = 0; i < packs.length; i += 1) {
    lastPromise = lastPromise.then(() => savePack(packs[i]));
  }

  return lastPromise.then(unitArray => Promise.resolve(unitArray));
}


export function getTreeWithSelectedChildren(tree, selected) {
  const treeWithChildren = unflattenEntities(tree, 'id', 'parentUnitId');
  const checkChildren = (unit, parent) => {
    if (unit.children && unit.children.length > 0) {
      unit.children.forEach(child => checkChildren(child, unit));
    }
    unit.childrenSelected = unit.children
      ? !unit.children.some(c => !c.childrenSelected)
      : selected.some(sel => unit.id === sel);
    if (parent && !parent.hasSelectedChildren) {
      parent.hasSelectedChildren =
        selected.some(sel => unit.id === sel) || unit.hasSelectedChildren;
    }
  };
  treeWithChildren.forEach(unit => checkChildren(unit));
  return treeWithChildren;
}

export function getChildren(sec) {
  const res = [];
  const pushChildren = (unit) => {
    if (unit.children && unit.children.length > 0) {
      unit.children.forEach(child => pushChildren(child));
    }
    res.push(unit);
  };
  pushChildren(sec);
  return res;
}



// WEBPACK FOOTER //
// ./src/Root/pages/Groups/GroupUnits/helper.js